import React, { createContext, useContext, useState, ReactNode } from 'react';

type LanguageContextType = {
  language: 'gr' | 'en';
  setLanguage: (lang: 'gr' | 'en') => void;
  t: (key: string) => string;
};

const translations = {
  // Navigation
  'nav.home': {
    en: 'Home',
    gr: 'Αρχική'
  },
  'nav.about': {
    en: 'About',
    gr: 'Ποιος είναι ο Mike'
  },
  'nav.book': {
    en: 'Get my Book',
    gr: 'Το e-Book μου'
  },
  'nav.services': {
    en: 'Services',
    gr: 'Υπηρεσίες'
  },
  'nav.contact': {
    en: 'Contact',
    gr: 'Επικοινωνία'
  },
  'nav.language': {
    en: 'Ελληνικά',
    gr: 'English'
  },
  'nav.growBusiness': {
    en: 'Grow Your Business',
    gr: 'Ζήτησε να σε καλέσουμε'
  },
  'nav.joinAlphaClique': {
    en: 'Join AlphaClique',
    gr: 'Δες πώς δουλεύει'
  },
  
  // New Hero Section
  'hero.newTitle': {
    en: 'I help entrepreneurs start, grow and sell online.',
    gr: 'Βοηθάω επιχειρηματίες να ξεκινήσουν, να αναπτυχθούν και να πουλήσουν online.'
  },
  'hero.newSubtitle': {
    en: 'Funnels. Content. AI. Branding. Everything you need to scale.',
    gr: 'Funnels. Περιεχόμενο. AI. Branding. Ό,τι χρειάζεσαι για να κάνεις scale.'
  },
  'hero.newCta': {
    en: 'See My Services',
    gr: 'Δες τις Υπηρεσίες μου'
  },
  
  // What I Do Section
  'whatIDo.title': {
    en: 'What I offer is simple: specific steps that lead to sales.',
    gr: 'Αυτό που προσφέρω είναι απλό: συγκεκριμένα βήματα που οδηγούν σε πωλήσεις.'
  },
  'whatIDo.service1': {
    en: 'Funnel & Landing Page Creation',
    gr: 'Δημιουργία Funnels & Landing Pages'
  },
  'whatIDo.service2': {
    en: 'Personal Branding & Content',
    gr: 'Προσωπικό Branding & Περιεχόμενο'
  },
  'whatIDo.service3': {
    en: 'Strategy & Mentoring',
    gr: 'Στρατηγική & Mentoring'
  },
  'whatIDo.service4': {
    en: 'AI tools for systems & automation',
    gr: 'AI εργαλεία για συστήματα & αυτοματοποίηση'
  },
  'whatIDo.cta': {
    en: 'Book An Appointment',
    gr: 'Κλείσε Ραντεβού'
  },
  
  // CTA Section
  'cta.title': {
    en: 'You can start today.',
    gr: 'Μπορείς να ξεκινήσεις σήμερα.'
  },
  'cta.subtitle': {
    en: 'The difference between an idea and a result is action.',
    gr: 'Η διαφορά μεταξύ ιδέας και αποτελέσματος είναι η δράση.'
  },
  'cta.button': {
    en: 'Talk To Me Now',
    gr: 'Μίλα μου τώρα'
  },
  
  // Testimonials
  'testimonials.title': {
    en: 'What clients say',
    gr: 'Τι λένε οι πελάτες'
  },
  
  // About Page specific
  'about.heroTitle': {
    en: 'Mike Foto',
    gr: 'Mike Foto'
  },
  'about.heroSubtitle': {
    en: 'Digital Growth | Funnels | AI',
    gr: 'Digital Growth | Funnels | AI'
  },
  'about.introText': {
    en: 'Mike Foto is one of the most practical and hands-on people in the digital business space. He doesn\'t sell theory. He builds, implements and transfers only what he has tested first himself.',
    gr: 'Ο Mike Foto είναι ένας από τους πιο πρακτικούς και hands-on ανθρώπους στο χώρο του digital business. Δεν πουλάει θεωρία. Χτίζει, εφαρμόζει και μεταφέρει μόνο όσα έχει δοκιμάσει πρώτα ο ίδιος.'
  },
  'about.backgroundTitle': {
    en: 'Where he started from',
    gr: 'Από πού ξεκίνησε'
  },
  'about.backgroundText1': {
    en: 'He started from the field of e-commerce and performance marketing, creating brands from scratch and learning through practice, failures and results.',
    gr: 'Ξεκίνησε από τον χώρο του e-commerce και του performance marketing, δημιουργώντας brands από το μηδέν και μαθαίνοντας μέσα από πράξη, αποτυχίες και αποτελέσματα.'
  },
  'about.backgroundText2': {
    en: 'Soon he became a consultant for businesses and creators who wanted not "ideas", but specific strategies that bring sales.',
    gr: 'Σύντομα μετατράπηκε σε σύμβουλο για επιχειρήσεις και δημιουργούς που ήθελαν όχι "ιδέες", αλλά συγκεκριμένες στρατηγικές που φέρνουν πωλήσεις.'
  },
  'about.currentTitle': {
    en: 'What he does today',
    gr: 'Τι κάνει σήμερα'
  },
  'about.currentIntro': {
    en: 'Today he is co-founder of two projects with intense development:',
    gr: 'Σήμερα είναι συνιδρυτής δύο projects με έντονη ανάπτυξη:'
  },
  'about.tapgDescription': {
    en: 'An NFC-first startup for businesses that want more reviews, leads and sales with one tap.',
    gr: 'Μια NFC-first startup για επιχειρήσεις που θέλουν περισσότερες αξιολογήσεις, leads και πωλήσεις με ένα tap.'
  },
  'about.rentmysiteDescription': {
    en: 'An innovative B2B solution that offers ready websites in 24 hours, without construction costs. Ideal for professionals who want fast and affordable online presence.',
    gr: 'Μια καινοτόμα B2B λύση που προσφέρει έτοιμες ιστοσελίδες σε 24 ώρες, χωρίς κόστη κατασκευής. Ιδανική για επαγγελματίες που θέλουν γρήγορη και προσιτή online παρουσία.'
  },
  'about.currentText': {
    en: 'At the same time, he helps entrepreneurs build funnels, design digital products, implement AI tools, and acquire a specific system for online development.',
    gr: 'Παράλληλα, βοηθά επιχειρηματίες να χτίσουν funnels, να σχεδιάσουν digital προϊόντα, να εφαρμόσουν AI εργαλεία, και να αποκτήσουν συγκεκριμένο σύστημα για online ανάπτυξη.'
  },
  'about.workingTitle': {
    en: 'How he works',
    gr: 'Πώς δουλεύει'
  },
  'about.workingText1': {
    en: 'Mike won\'t tell you what to do. He will show you how to build it, step by step, and give you the templates, tools and support to do it.',
    gr: 'Ο Mike δεν θα σας πει τι να κάνετε. Θα σας δείξει πώς να το χτίσετε, βήμα προς βήμα, και θα σας δώσει τα templates, τα εργαλεία και την υποστήριξη για να το κάνετε.'
  },
  'about.workingText2': {
    en: 'He doesn\'t do "branding". He creates infrastructures that sell.',
    gr: 'Δεν κάνει "branding". Δημιουργεί υποδομές που πουλάνε.'
  },
  'about.ctaTitle': {
    en: 'If you want to work with him or see more of his work:',
    gr: 'Αν θέλετε να δουλέψετε μαζί του ή να δείτε περισσότερα από το έργο του:'
  },
  'about.ctaServices': {
    en: 'View Services',
    gr: 'Δείτε τις Υπηρεσίες'
  },
  'about.ctaWork': {
    en: 'Mike\'s Work',
    gr: 'Το Έργο του Mike'
  },
  
  // Services Page
  'services.pageTitle': {
    en: 'Services focused on results.',
    gr: 'Υπηρεσίες που εστιάζουν σε αποτελέσματα.'
  },
  'services.heroTitle': {
    en: 'Complete Digital Growth Solutions',
    gr: 'Ολοκληρωμένες Λύσεις Digital Growth'
  },
  'services.heroSubtitle': {
    en: 'Not isolated services. A system that brings measurable results.',
    gr: 'Όχι μεμονωμένες υπηρεσίες. Ένα σύστημα που φέρνει μετρήσιμα αποτελέσματα.'
  },
  'services.heroButton': {
    en: 'Start Today',
    gr: 'Ξεκινήστε Σήμερα'
  },
  'services.strategyTitle': {
    en: 'Integrated Development Strategy',
    gr: 'Στρατηγική Ολοκληρωμένης Ανάπτυξης'
  },
  'services.strategyText1': {
    en: 'Mike Foto offers complete solutions, not isolated services. Every element (website, funnel, NFC, AI) is part of a unified system that brings measurable results.',
    gr: 'Ο Mike Foto προσφέρει ολοκληρωμένες λύσεις, όχι μεμονωμένες υπηρεσίες. Κάθε στοιχείο (website, funnel, NFC, AI) είναι μέρος ενός ενιαίου συστήματος που φέρνει μετρήσιμα αποτελέσματα.'
  },
  'services.strategyText2': {
    en: 'Online success requires strategy, speed and technology that work together flawlessly.',
    gr: 'Η online επιτυχία απαιτεί στρατηγική, ταχύτητα και τεχνολογία που συνεργάζονται άψογα.'
  },
  'services.strategyText3': {
    en: 'We don\'t just build websites - we create growth systems that work 24/7.',
    gr: 'Δεν χτίζουμε απλά websites - δημιουργούμε συστήματα ανάπτυξης που λειτουργούν 24/7.'
  },
  'services.coreTitle': {
    en: 'Core Services',
    gr: 'Οι Βασικές Υπηρεσίες'
  },
  'services.websiteTitle': {
    en: 'Website & Eshop in 24 hours',
    gr: 'Website & Eshop σε 24 ώρες'
  },
  'services.websiteDesc': {
    en: 'We design and deliver functional websites and eshops that are ready for sales immediately. No construction costs, no delays.',
    gr: 'Σχεδιάζουμε και παραδίδουμε λειτουργικά websites και eshop που είναι έτοιμα για πωλήσεις άμεσα. Χωρίς κόστος κατασκευής, χωρίς καθυστερήσεις.'
  },
  'services.nfcTitle': {
    en: 'NFC for reviews/leads',
    gr: 'NFC για reviews/leads'
  },
  'services.nfcDesc': {
    en: 'NFC technology that enhances reviews, lead collection and your business\'s social presence.',
    gr: 'Τεχνολογία NFC που ενισχύει τα reviews, τη συλλογή leads και την παρουσία της επιχείρησής σας στα social.'
  },
  'services.funnelsTitle': {
    en: 'Funnels with AI optimization',
    gr: 'Funnels με AI optimization'
  },
  'services.funnelsDesc': {
    en: 'Strategically designed to convert visitors into customers. Using AI for optimization and scaling.',
    gr: 'Στρατηγικά σχεδιασμένα για να μετατρέπουν επισκέπτες σε πελάτες. Με χρήση AI για βελτιστοποίηση και scaling.'
  },
  'services.coachingTitle': {
    en: 'B2B Coaching + AI growth strategy',
    gr: 'B2B Coaching + AI growth strategy'
  },
  'services.coachingDesc': {
    en: 'Complete guidance to build systems that bring measurable results and revenue.',
    gr: 'Πλήρης καθοδήγηση για να χτίσετε συστήματα που φέρνουν μετρήσιμα αποτελέσματα και έσοδα.'
  },
  'services.testimonialQuote': {
    en: '«Mike\'s strategy changed our online game. In 30 days we saw a 3x increase in leads.»',
    gr: '«Η στρατηγική του Mike άλλαξε το online game μας. Σε 30 μέρες είδαμε 3x αύξηση στα leads.»'
  },
  'services.testimonialAuthor': {
    en: 'Entrepreneur, Thessaloniki',
    gr: 'Επιχειρηματίας, Θεσσαλονίκη'
  },
  'services.aiTitle': {
    en: 'AI & Automation',
    gr: 'AI & Automation'
  },
  'services.aiBullet1': {
    en: 'Faster content production',
    gr: 'Πιο γρήγορη παραγωγή περιεχομένου'
  },
  'services.aiBullet2': {
    en: 'Automatic campaign optimization',
    gr: 'Αυτόματη βελτιστοποίηση campaigns'
  },
  'services.aiBullet3': {
    en: 'Less cost, more results',
    gr: 'Λιγότερο κόστος, περισσότερα αποτελέσματα'
  },
  'services.aiBullet4': {
    en: '24/7 lead nurturing and follow-up',
    gr: '24/7 lead nurturing και follow-up'
  },
  'services.finalCtaTitle': {
    en: 'Are you ready to see how this system works for your business?',
    gr: 'Είσαι έτοιμος να δείς πώς αυτό το σύστημα δουλεύει για την επιχείρησή σου;'
  },
  'services.finalCtaButton': {
    en: 'Work with Mike ➤',
    gr: 'Work with Mike ➤'
  },
  
  // CTA Bar
  'ctaBar.title': {
    en: 'Start today',
    gr: 'Ξεκινήστε σήμερα'
  },
  'ctaBar.subtitle': {
    en: 'Every day lost is untapped revenue',
    gr: 'Η κάθε μέρα που χάνεται, είναι έσοδα που μένουν ανεκμετάλλευτα'
  },
  'ctaBar.button': {
    en: 'START TODAY',
    gr: 'ΞΕΚΙΝΗΣΤΕ ΣΗΜΕΡΑ'
  },
  
  // Book Section
  'book.title': {
    en: 'Funnel Like a Pro',
    gr: 'Funnel Like a Pro'
  },
  'book.subtitle': {
    en: 'Master the art of creating high-converting funnels, perfect your VSL format, and build automated systems that sell while you sleep.',
    gr: 'Μάθετε την τέχνη της δημιουργίας funnels υψηλής μετατροπής, τελειοποιήστε το VSL format σας και χτίστε αυτοματοποιημένα συστήματα που πωλούν ενώ κοιμάστε.'
  },
  'book.discoveryTitle': {
    en: 'Free Discovery Call',
    gr: 'Δωρεάν Αναγνωριστική Κλήση'
  },
  'book.discoverySubtitle': {
    en: 'Learn how we can help your business grow online',
    gr: 'Μάθετε πώς μπορούμε να βοηθήσουμε την επιχείρησή σας να αναπτυχθεί online'
  },
  'book.learnTitle': {
    en: 'In 30 minutes you will learn:',
    gr: 'Στα 30 λεπτά θα μάθετε:'
  },
  'book.learn1': {
    en: '• What is the best strategy for your industry',
    gr: '• Ποια είναι η καλύτερη στρατηγική για τον κλάδο σας'
  },
  'book.learn2': {
    en: '• How to increase your leads immediately',
    gr: '• Πώς να αυξήσετε τα leads σας άμεσα'
  },
  'book.learn3': {
    en: '• What tools you really need',
    gr: '• Ποια εργαλεία χρειάζεστε πραγματικά'
  },
  'book.learn4': {
    en: '• The next step for your growth',
    gr: '• Το επόμενο βήμα για την ανάπτυξή σας'
  },
  'book.ctaButton': {
    en: 'Book your free call',
    gr: 'Κλείστε τη δωρεάν κλήση'
  },
  
  // Brands Section
  'brands.title': {
    en: 'Our Brands',
    gr: 'Τα Brands μας'
  },
  'brands.rentmysite': {
    en: 'Ready websites and eshop in 24 hours, no construction costs.',
    gr: 'Έτοιμες ιστοσελίδες και eshop σε 24 ώρες, χωρίς έξοδα κατασκευής.'
  },
  'brands.tapg': {
    en: 'NFC solutions for instant review and lead collection.',
    gr: 'NFC λύσεις για άμεση συλλογή reviews και leads.'
  },
  'brands.upplead': {
    en: 'Funnels and landing pages with AI for measurable results.',
    gr: 'Funnels και landing pages με χρήση AI για μετρήσιμα αποτελέσματα.'
  },
  
  // B2B Coaching Section
  'b2bCoaching.title': {
    en: 'B2B Coaching + AI Growth Strategy',
    gr: 'B2B Coaching + AI Growth Strategy'
  },
  'b2bCoaching.subtitle': {
    en: 'Complete guidance to build systems that bring measurable results',
    gr: 'Πλήρης καθοδήγηση για να χτίσετε συστήματα που φέρνουν μετρήσιμα αποτελέσματα'
  },
  'b2bCoaching.benefit1': {
    en: 'Strategic growth plan',
    gr: 'Στρατηγικό πλάνο ανάπτυξης'
  },
  'b2bCoaching.benefit2': {
    en: 'Systems that increase leads and sales',
    gr: 'Συστήματα που αυξάνουν leads και πωλήσεις'
  },
  'b2bCoaching.benefit3': {
    en: 'AI for content, funnels and ads',
    gr: 'AI για περιεχόμενο, funnels και διαφημίσεις'
  },
  'b2bCoaching.benefit4': {
    en: 'Immediate measurable results',
    gr: 'Άμεσα μετρήσιμα αποτελέσματα'
  },
  'b2bCoaching.button': {
    en: 'Start Coaching',
    gr: 'Ξεκινήστε το Coaching'
  },
  
  // Services Page
  'services.funnel.title': {
    en: 'Funnel & Landing Page Creation',
    gr: 'Δημιουργία Funnel & Landing Page'
  },
  'services.funnel.description': {
    en: "I build pages designed for one thing: to sell. With VSL, hooks, and call-to-actions that work.",
    gr: 'Χτίζω σελίδες που φτιάχτηκαν για ένα πράγμα: να πουλάνε. Με VSL, hooks και call-to-actions που δουλεύουν.'
  },
  'services.content.title': {
    en: 'Social Media Content',
    gr: 'Περιεχόμενο για Social Media'
  },
  'services.content.description': {
    en: 'Shortform videos for TikTok, Instagram & YouTube Shorts. Script, filming, captions & scaling.',
    gr: 'Shortform βίντεο για TikTok, Instagram & YouTube Shorts. Σενάριο, γυρίσματα, captions & scaling.'
  },
  'services.ai.title': {
    en: 'AI Systems & Automation',
    gr: 'AI Συστήματα & Αυτοματοποίηση'
  },
  'services.ai.description': {
    en: 'I offer practical solutions with AI for eBooks, images, workflows, email sequences, and sales tools.',
    gr: 'Προσφέρω πρακτικές λύσεις με AI για eBooks, images, workflows, email sequences και εργαλεία πωλήσεων.'
  },
  'services.mentoring.title': {
    en: '1-on-1 Mentoring',
    gr: '1-on-1 Mentoring'
  },
  'services.mentoring.description': {
    en: 'Strategy to start or scale. If you have a goal, I find the way to achieve it.',
    gr: 'Στρατηγική για start ή scale. Αν έχεις στόχο, βρίσκω τον δρόμο να τον πετύχεις.'
  },
  'services.formTitle': {
    en: 'Request a call back',
    gr: 'Ζήτησε να σε καλέσω'
  },
  'services.formName': {
    en: 'Full Name',
    gr: 'Ονοματεπώνυμο'
  },
  'services.formInterest': {
    en: 'What interests you the most?',
    gr: 'Τι σε ενδιαφέρει περισσότερο;'
  },
  'services.formMessage': {
    en: 'Message',
    gr: 'Μήνυμα'
  },
  'services.formSubmit': {
    en: 'Submit',
    gr: 'Υποβολή'
  },
  
  // My Work Page
  'work.pageTitle': {
    en: 'My Work',
    gr: 'Το Έργο μου'
  },
  'work.intro': {
    en: "I'm a co-founder of brands that work in practice. I don't stay in theory. I build and evolve every day.",
    gr: 'Είμαι συνιδρυτής brands που λειτουργούν στην πράξη. Δεν μένω στη θεωρία. Χτίζω και εξελίσσω κάθε μέρα.'
  },
  'work.tapg.title': {
    en: 'TapG - NFC for business growth',
    gr: 'TapG – NFC για επιχειρηματική ανάπτυξη'
  },
  'work.tapg.description': {
    en: 'TapG is the first Greek platform that turns a simple tap into a Google review, social follow, or purchase. Products such as InfoPlates, NFC cards, and stickers, all designed for physical businesses that want more results with less effort.',
    gr: 'Η TapG είναι η πρώτη ελληνική πλατφόρμα που μετατρέπει ένα απλό tap σε Google αξιολόγηση, social follow ή αγορά. Προϊόντα όπως InfoPlates, NFC κάρτες και αυτοκόλλητα, όλα σχεδιασμένα για φυσικές επιχειρήσεις που θέλουν περισσότερα αποτελέσματα με λιγότερο κόπο.'
  },
  'work.tapg.cta': {
    en: 'Visit TapG.gr',
    gr: 'Επισκέψου το TapG.gr'
  },
  'work.alpha.title': {
    en: 'AlphaClique - From 0 to your first sales',
    gr: 'AlphaClique – Από το 0 στις πρώτες σου πωλήσεις'
  },
  'work.alpha.description': {
    en: 'A community, a system, one mission: to help people create digital assets and gain online income. Training, tools, mentoring. All together.',
    gr: 'Μια κοινότητα, ένα σύστημα, μία αποστολή: να βοηθήσουμε άτομα να δημιουργήσουν ψηφιακά assets και να αποκτήσουν online εισόδημα. Εκπαίδευση, εργαλεία, mentoring. Όλα συγκεντρωμένα.'
  },
  'work.alpha.cta': {
    en: 'Join AlphaClique',
    gr: 'Μπες στο AlphaClique'
  },
  
  // E-Book Page
  'ebook.title': {
    en: 'Download my eBook - Free',
    gr: 'Κατέβασε το eBook μου – Δωρεάν'
  },
  'ebook.description': {
    en: 'Learn how to create and sell your own eBook in 24 hours. No knowledge, no investments, no excuses.',
    gr: 'Μάθε πώς να δημιουργήσεις και να πουλήσεις ένα δικό σου eBook μέσα σε 24 ώρες. Χωρίς γνώσεις, χωρίς επενδύσεις, χωρίς δικαιολογίες.'
  },
  'ebook.cta': {
    en: 'Download Now (.pdf)',
    gr: 'Κατέβασε το τώρα (.pdf)'
  },
  
  // Links Page
  'links.name': {
    en: 'Mike Foto',
    gr: 'Mike Foto'
  },
  'links.tagline': {
    en: 'Digital Growth | Funnels | AI',
    gr: 'Digital Growth | Funnels | AI'
  },
  'links.appointment': {
    en: 'Book an Appointment',
    gr: 'Κλείσε Ραντεβού'
  },
  'links.whatsapp': {
    en: 'WhatsApp Contact',
    gr: 'WhatsApp Επικοινωνία'
  },
  'links.viber': {
    en: 'Viber Contact',
    gr: 'Viber Επικοινωνία'
  },
  'links.tapg': {
    en: 'TapG.gr',
    gr: 'TapG.gr'
  },
  'links.review': {
    en: 'Rate me on Google',
    gr: 'Αξιολόγησέ με στο Google'
  },
  'links.payment': {
    en: 'Make Your Payment',
    gr: 'Κάνε την Πληρωμή σου'
  },
  
  // Contact Page
  'contact.title': {
    en: 'Talk to me',
    gr: 'Μίλα μου'
  },
  'contact.description': {
    en: 'Have a question or want to work together? Send me a message and I will respond within 24 hours.',
    gr: 'Έχεις κάποια ερώτηση ή θέλεις να συνεργαστούμε; Στείλε μου μήνυμα και θα απαντήσω μέσα σε 24 ώρες.'
  },
  'contact.name': {
    en: 'Name',
    gr: 'Όνομα'
  },
  'contact.message': {
    en: 'Message',
    gr: 'Μήνυμα'
  },
  'contact.send': {
    en: 'Send',
    gr: 'Αποστολή'
  },
  'contact.email': {
    en: 'Email: info@mikefoto.gr',
    gr: 'Email: info@mikefoto.gr'
  },
  
  // Hero Section
  'hero.title': {
    en: 'Start or Scale Your Online Business — Faster',
    gr: 'Η επιχείρησή σου δεν χρειάζεται άλλον έναν υπάλληλο. Χρειάζεται έναν σύμμαχο.'
  },
  'hero.subtitle': {
    en: 'From zero to €10,000 and beyond. Practical strategies. Fast execution. No fluff.',
    gr: 'Ο Mike Foto χτίζει συστήματα, περιεχόμενο και funnels που φέρνουν πωλήσεις.'
  },
  'hero.join': {
    en: 'Join AlphaClique or Grow your brand with me.',
    gr: 'Συνεργάσου με την ομάδα μας για αποτελέσματα.'
  },
  
  // About Section
  'about.intro': {
    en: 'I\'m',
    gr: 'Είμαι ο'
  },
  'about.name': {
    en: 'Mike Foto',
    gr: 'Mike Foto'
  },
  'about.description': {
    en: 'I\'ve built brands through e-commerce, dropshipping, and B2B agency work. As the co-founder of TapG.gr and AlphaClique, I help entrepreneurs and brands leverage AI and smart systems to grow and scale profitably.',
    gr: 'Έχω αναπτύξει brands μέσω e-commerce, dropshipping και B2B συνεργασιών. Ως συνιδρυτής των TapG.gr και AlphaClique, βοηθάω επιχειρηματίες και brands να αξιοποιήσουν την AI και τα έξυπνα συστήματα για να αναπτυχθούν κερδοφόρα.'
  },
  'about.learnMore': {
    en: 'Learn More About Me',
    gr: 'Μάθε περισσότερα για εμένα'
  },
  'about.testimonial': {
    en: '"Zero experience and no idea where to start. 2 months later, I crossed 10,000€ in revenue with a system that basically runs itself — no tech skills, it was way easier than I thought."',
    gr: '"Μηδενική εμπειρία και καμία ιδέα από πού να ξεκινήσω. 2 μήνες αργότερα, ξεπέρασα τα 10.000€ σε έσοδα με ένα σύστημα που ουσιαστικά λειτουργεί μόνο του — χωρίς τεχνικές γνώσεις, ήταν πολύ πιο εύκολο από ό,τι νόμιζα."'
  },
  'about.testimonialAuthor': {
    en: 'Chris A.',
    gr: 'Χρήστος Α.'
  },
  'about.trustedBy': {
    en: 'Trusted By',
    gr: 'Μας Εμπιστεύονται'
  },
  'about.bio': {
    en: 'Mike Foto is an entrepreneur, creator and growth expert who helps professionals build funnels, automations and digital assets that generate sales.',
    gr: 'Ο Mike Foto είναι επιχειρηματίας, δημιουργός και growth expert που βοηθάει επαγγελματίες να χτίσουν funnels, automations, και digital περιουσιακά στοιχεία που παράγουν πωλήσεις.'
  },
  'about.experience': {
    en: 'He has worked with businesses, personal brands and new creators, offering strategy, production and implementation.',
    gr: 'Έχει εργαστεί με επιχειρήσεις, personal brands και νέους δημιουργούς, προσφέροντας στρατηγική, παραγωγή και υλοποίηση.'
  },
  
  // Services Section
  'services.title': {
    en: 'Looking to grow your business?',
    gr: 'Θέλεις να αναπτύξεις την επιχείρησή σου;'
  },
  'services.subtitle': {
    en: 'From AI funnels to content creation, we deliver solutions that bring real results.',
    gr: 'Από AI funnels μέχρι δημιουργία περιεχομένου, προσφέρουμε λύσεις που φέρνουν πραγματικά αποτελέσματα.'
  },
  'services.services': {
    en: 'Services',
    gr: 'Υπηρεσίες'
  },
  
  // Footer
  'footer.quickLinks': {
    en: 'Quick Links',
    gr: 'Γρήγοροι Σύνδεσμοι'
  },
  'footer.services': {
    en: 'Services',
    gr: 'Υπηρεσίες'
  },
  'footer.subscribe': {
    en: 'Subscribe',
    gr: 'Εγγραφή'
  },
  'footer.subscribeText': {
    en: 'Get strategies and systems to grow your business.',
    gr: 'Λάβετε στρατηγικές και συστήματα για να αναπτύξετε την επιχείρησή σας.'
  },
  'footer.email': {
    en: 'Your email',
    gr: 'Το email σας'
  },
  'footer.privacy': {
    en: 'By subscribing, you agree to our Privacy Policy.',
    gr: 'Με την εγγραφή σας, συμφωνείτε με την Πολιτική Απορρήτου μας.'
  },
  'footer.rights': {
    en: 'All rights reserved.',
    gr: 'Με επιφύλαξη παντός δικαιώματος.'
  },
  'footer.privacyPolicy': {
    en: 'Privacy Policy',
    gr: 'Πολιτική Απορρήτου'
  },
  'footer.terms': {
    en: 'Terms of Service',
    gr: 'Όροι Χρήσης'
  }
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<'gr' | 'en'>('gr'); // Default to Greek now

  const t = (key: string): string => {
    const translation = translations[key as keyof typeof translations];
    if (!translation) return key;
    return translation[language];
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
